import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import HeaderNavigation from './HeaderNavigation';
import UserInformation from './UserHeader';
import UserMenu from './UserMenu';

const Header = ({products, user, userMenuItems, hinderNav}) => {
  const [headerData, setHeaderData] = React.useState(
    {
      open: false,
      cls: 'settings-drop menu-dropdown dropdown--dark transition',
      clsOpen: 'open'
    });
    
  const ciLogo = process.env.REACT_APP_STATIC_IMG_URL + '/logo/creditinfo-logo-black-text.png';                                            

  const toggleSide = () => {
    setHeaderData({...headerData, open : !headerData.open });
  };

  return (
    <div>
      {headerData.open && (
        <div
          style={{
            position: 'absolute',
            left: '0',
            top: '0',
            height: '100%',
            width: '100%',
            zIndex: 2
          }}
          onClick={toggleSide}
        />
      )}
      <header id="main-header" className="main-header">
        <div className="grid" style={{ height: '100%' }}>
          <div className="col s4of6 logo-print-margin">
            {!hinderNav &&
              products && products.length > 0 && (
                <span
                  className="mobilenav-toggle button icon-grid no-text white"
                  onClick={toggleSide}
                />
              )}
            <Link to="/">
              <img className="logo" src={ciLogo} alt="Creditinfo" />
            </Link>            
            <HeaderNavigation products={products} />
          </div>
          <div className="col s2of6 no-print" style={{ height: '100%' }}>
            <UserInformation user={user} onMenuClick={toggleSide} />
          </div>
        </div>
        <UserMenu open={headerData.open} items={userMenuItems} toggleMenu={toggleSide} hinderNav={hinderNav} />
      </header>
    </div>
  );
}

Header.propTypes = {  
  user: PropTypes.object,
  products : PropTypes.array,
  userMenuItems : PropTypes.array,
  hinderNav : PropTypes.bool
};


export default Header;
